module.exports = __webpack_public_path__ + "static/media/schlix.a1c08833.svg";